<template>
    <div class="col-12">
        <div class="annotations-side-card" @click.prevent="onSelect" @mouseenter="onGeometryHighlight(rid)" @mouseleave="onGeometryHighlight(rid, false)">
            <div class="annotations-side-card__wrapper">
                <div class="annotations-side-card__wrapper__container">
                   <div class="side-card-content">
                      <div class="side-card-content__left-container">
                         <div class="side-card-info">
                            <div class="side-card-info__title">
                                <span>{{ title }}</span>
                            </div>
                            <div class="side-card-info__desc" v-if="description">
                               <span>
                                  <div v-html="description"></div>
                               </span>
                            </div>
                         </div>
                      </div>
                      <div class="side-card-content__right-container">
                         <div class="side-card-tool text-center">
                            <div class="btn-group my-0">
                                <button
                                    v-if="zoomToCollection"
                                    type="button"
                                    class="btn btn-sm min-w-auto btn-add"
                                    data-toggle="tooltip-city"
                                    title="Zoom para Anotação"
                                    @click.stop="onZoomTo">
                                    <i class="fas fa-search-location"></i>
                                </button>
                                <button
                                    v-if="showHideCollection"
                                    type="button"
                                    class="btn btn-sm min-w-auto btn-add"
                                    data-toggle="tooltip-city"
                                    :title="visibility ? 'Esconder Anotação' : 'Mostrar Anotação'"
                                    @click.stop="onToogleVisibility">
                                    <i class="fas" :class="[visibility ? 'fa-eye' : 'fa-eye-slash']"></i>
                                </button>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AnnotationMixin from './../AnnotationMixin';

    export default {
        name: 'AnnotationRecordGridItem',
        mixins: [
            AnnotationMixin,
        ],
        props: {
            moduleCode: {
                type: String,
                require: true,
            },
            map: {
                type: Object,
                require: true,
                default: () => {},
            },
            record: {
                type: Object,
                required: true,
                default: () => {},
            },
            zoomToCollection: {
                type: Boolean,
                default: true,
            },
            showHideCollection: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                active: false,
            }
        },
        mounted() {
            this.initialize();
        },
        computed: {
            properties() {
                return this.record.properties || {};
            },
            rid() {
                return this.properties.id || '';
            },
            title() {
                return this.properties.title || '';
            },
            description() {
                return this.$sanitize(this.properties.description || '');
            },
            visibility() {
                return !!this.properties.visibility;
            },
        },
        methods: {
            initialize() {
                // this.setFeatures();
            },
            reset() {
                // this.recordFeatures = new Collection();
            },
            forceVisibility() {
                if(!this.visibility){
                    this.onToogleVisibility(event, true);
                }
            },
            onSelect() {
                this.forceVisibility();
                this.$emit('selectedRecord', this.rid);
            },
            onZoomTo(event) {
                this.hideTooltip();
                this.forceVisibility();
                this.$emit('zoomToRecord', this.rid);
            },
            onToogleVisibility(event, force = undefined) {
                this.hideTooltip();
                this.properties.visibility = force !== undefined ? force : !!!this.visibility;
                this.$emit('changeRecord', {
                    id: this.rid,
                    record: {
                        visibility: this.visibility,
                    }
                });
            },
            onGeometryHighlight(id, highlight = true) {
                this.$emit('geometryHighlight', {id, highlight});
            },
            // setFeatures() {
            //     // let features = new GeoJSON().readFeatures(this.record);
            //     // this.$set(this.record, 'features', features);
            //     // this.renderRecord();
            // },
            renderRecord: function() {
                this.$emit('renderRecord', {
                    id: this.rid,
                    visibility: this.visibility,
                });
            },
        },
    }
</script>